import faq from '@americanexpress/iguazu-resources/faq';
import content from './tncFetch';
import trips from './trips';
import alert from './alert';
import program from './program';
import tripDetails from './tripDetails';
import preCxlPolicies from './preCxlPolicies';
import cxlCancellation from './cxlCancellation';
import chatbotAuthorize from './chatbotAuthorize';
import toggleFeature from './toggleFeature';
import receipts from './receipts';
import traveler from './traveler';
import oneCMSInternetContent from './oneCMSInternetContent';
import benefitTerms from './benefitTerms';
import termsContent from './termsAndConditonsContentFetch';
import printDetails from './printDetails';
import dynamicBenefits from './dynamicBenefits';
import cancelForm from './cancelForm';
import shareEmailItinerary from './shareEmailItinerary';
import intlOnlineCancellation from './intlOnlineCancellation';
import crossSell from './crossSell';
import scheduleChangeManager from './scheduleChangeManager';
import airAncillaries from './airAncillaries';
import estimatedTaxesAndFees from './estimatedTaxesAndFees';
import memberProducts from './memberProducts';
import unusedCredit from './unusedCredit';
import lowestRateGuaranteedClaim from './lowestRateGuaranteedClaimForm';

export default {
  faq,
  content,
  trips,
  alert,
  program,
  tripDetails,
  preCxlPolicies,
  cxlCancellation,
  chatbotAuthorize,
  toggleFeature,
  receipts,
  traveler,
  oneCMSInternetContent,
  benefitTerms,
  termsContent,
  printDetails,
  dynamicBenefits,
  cancelForm,
  shareEmailItinerary,
  intlOnlineCancellation,
  crossSell,
  scheduleChangeManager,
  airAncillaries,
  estimatedTaxesAndFees,
  memberProducts,
  unusedCredit,
  lowestRateGuaranteedClaim,
};
